import * as React from 'react';
import {Field, InjectedFormProps} from 'redux-form';
import FieldFormControl from '../../../FieldFormControl';
import {HelpBlock} from 'react-bootstrap';
import {isRequired} from '../../../../util/validators';

interface ICheckboxField {
  label: string;
  name: string;
}
interface ICheckboxGroupProps extends InjectedFormProps {
  fields: ICheckboxField[];
  meta ?: {error, touched, submitFailed};
  handleOnChange?: any;
}

export class CheckboxField extends React.Component<ICheckboxGroupProps> {

  public render() {
    const { meta, handleOnChange } = this.props;
    const hasError = meta.submitFailed && meta.error;
    return (
      <div className={hasError ? 'has-error' : ''}>
        {this.props.fields.map((field, index) => {
          return (
            <Field
              key={index}
              name={field.name}
              type="checkbox"
              component={FieldFormControl}
              validate={[isRequired]}
              onChange={handleOnChange}
            >
              <div />
              <span>{field.label}</span>
            </Field>
            );
        })}
        {hasError && (<HelpBlock className={'margin-top'}>{meta.error}</HelpBlock>)}
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/CheckboxGroup/components/CheckboxField/index.tsx